import React from "react";

import { useTranslation } from "react-i18next";

import { WhoWinsFirstHalf } from "@data-types/sport-stats/SportStatsTypes";
import RecentGames from "../RecentGames";

import Graph from "../Graph";

export default function WhoWinsFirstHalfStatistics(props: {
	homeTeam: WhoWinsFirstHalf["data"];
	awayTeam: WhoWinsFirstHalf["data"];
}) {
	const { t } = useTranslation();

	return (
		<>
			<RecentGames
				homeTeamEventCount={props.homeTeam?.eventCount}
				awayTeamEventCount={props.awayTeam?.eventCount}
			/>
			<Graph
				title={t("EVENT.STATISTICS.BETTING_TYPE_STATS.GAMES_WON_FIRST")}
				home={t("OFFER.COMPETITORS.HOME")}
				away={t("OFFER.COMPETITORS.AWAY")}
				data={{
					homeValue: props.homeTeam?.gamesWonFirstHalf,
					awayValue: props.awayTeam?.gamesWonFirstHalf,
				}}
				isPercentage
			/>
		</>
	);
}
